import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_USER_QUEUE_REQUEST = 'GET_USER_QUEUE_REQUEST';
export const GET_USER_QUEUE_SUCCESS = 'GET_USER_QUEUE_SUCCESS';
export const GET_USER_QUEUE_FAILURE = 'GET_USER_QUEUE_FAILURE';

function request() {
  return {
    type: GET_USER_QUEUE_REQUEST,
  };
}

function receive(userQueue) {
  return {
    type: GET_USER_QUEUE_SUCCESS,
    userQueue
  };
}

function reject(error) {
  return {
    type: GET_USER_QUEUE_FAILURE,
  };
}

export function getUserQueue(workflow, pageNumber, pageSize, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes, sortByField, sortDirection, filterList) {
  return (dispatch) => {
    dispatch(request());

    return ApiService
      .getUserQueue(workflow, pageNumber, pageSize, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes, sortByField, sortDirection, filterList)
      .then((response) => {
        dispatch(receive(response.data.myWork));
      }).catch((error) => {
        dispatch(handleException(error, reject, true));
      });
  };
}

export function getUserQueueByObject(requestObject) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getUserQueue(
        requestObject.workflow,
        requestObject.pageNumber,
        requestObject.pageSize,
        requestObject.searchQuery,
        requestObject.legalEntity,
        requestObject.legalEntitySelected,
        requestObject.accountNumber,
        requestObject.accountNumberSelected,
        requestObject.customer,
        requestObject.customerSelected,
        requestObject.formTypes,
        requestObject.sortByField,
        requestObject.sortDirection,
        requestObject.filterList
      )
      .then((response) => {
        dispatch(receive(response.data.myWork));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
